module.exports = __webpack_public_path__ + "img/wz-8-6-6.8dd44ef2.jpg";